import { render, staticRenderFns } from "./SurveyFormRadio.vue?vue&type=template&id=2fb020ce&scoped=true&"
import script from "./SurveyFormRadio.vue?vue&type=script&lang=js&"
export * from "./SurveyFormRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb020ce",
  null
  
)

export default component.exports